import React, { CSSProperties, MouseEventHandler } from 'react';

import { LoadingSpinner } from 'assets/icons/loading-spinner';
import { cn } from 'utils/cn';

interface Props {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  className?: string;
  style?: CSSProperties;
  disabled?: boolean;
  type?: HTMLButtonElement['type'];
  ref?: React.RefObject<HTMLButtonElement>;
  isLoading?: boolean;
}

export const ButtonCTA = React.forwardRef<HTMLButtonElement, Props & JSX.IntrinsicElements['button']>(
  ({ children, onClick, className, style, disabled, type, isLoading, ...props }, ref) => {
    return (
      <button
        {...props}
        ref={ref}
        className={cn(
          'py-2 px-9 rounded-[12px] bg-sf-prim-cta transition-all text-icn-txt-white',
          !disabled && 'hover:bg-sf-prim-cta-hov active:bg-sf-prim-cta-pres',
          disabled && 'bg-bg-sec-0-100 text-icn-txt-tert',
          'outline-none focus:ring-transparent focus:ring-offset-0 focus:ring-0',
          'text-heading-5',
          'focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-offset-bg-prim-w-b focus-visible:ring-[#1D76ED]',
          className
        )}
        disabled={disabled || isLoading}
        style={style}
        onClick={onClick}
        type={type}
      >
        <div className="w-full flex items-center justify-center">
          {isLoading ? <LoadingSpinner className="w-5 h-5" strokeBgClassName="stroke-bg-sec-0-90" circleClassName="stroke-icn-txt-tert" /> : children}
        </div>
      </button>
    );
  }
);

ButtonCTA.displayName = 'ButtonCTA';

export default ButtonCTA;
